import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function SalesLetter() {
  const painPoints = ['Quieres preparar café como un barista profesional, pero desde tu propia cocina.', 'Sueñas con disfrutar bebidas de cafetería sin tener que salir de casa todos los días.', 'Eres de los que entienden que el café no es solo una bebida, es un ritual que define tu día.', 'Amas el café y quieres entenderlo a fondo: sus orígenes, aromas y secretos.', 'Tu café de todos los días ya no te emociona y sabes que podría ser mucho mejor.'];
  const solutions = ['Aprenderás a preparar café como un barista, logrando textura, aroma y sabor profesional.', 'Dominarás técnicas para preparar bebidas de cafetería desde casa, con resultados increíbles.', 'Entenderás el café de verdad: sus orígenes, aromas y métodos de preparación.', 'Aprenderás a crear y compartir recetas únicas: bebidas frías, bebidas calientes, bebidas con leche, postres con café.', 'Dominarás el equilibrio entre técnica, sabor y presentación, como en una cafetería profesional.'];
  return <section className="py-16 md:py-24 px-4 bg-cream-200/50" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-126">
          <p className="text-xl md:text-2xl text-espresso-800 leading-relaxed font-medium" data-id="element-127">
            Si estás aquí, es porque quieres disfrutar el café de verdad: con
            sabor, técnica y estilo…{' '}
            <span className="italic text-gold-700" data-id="element-128">
              como si estuvieras en una cafetería.
            </span>
          </p>
          <p className="mt-6 text-lg text-espresso-700" data-id="element-129">
            Despídete del café mediocre y dale la bienvenida al arte de preparar
            café estilo cafetería en casa.
          </p>
        </motion.div>

        {/* Pain Points */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-espresso-900/5 mb-12" data-id="element-130">
          <h2 className="text-2xl md:text-3xl font-bold text-espresso-900 mb-8 text-center" data-id="element-131">
            ESTE LIBRO DIGITAL ES PARA TI SI…
          </h2>
          <ul className="space-y-6" data-id="element-132">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-133">
                <XCircle className="w-6 h-6 text-danger flex-shrink-0 mt-0.5" data-id="element-134" />
                <span className="text-lg text-espresso-800" data-id="element-135">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        {/* Solutions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-espresso-900 text-cream-100 rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-136">
          <h2 className="text-2xl md:text-3xl font-bold text-gold-500 mb-8 text-center" data-id="element-137">
            ¿QUÉ APRENDERÁS CON EL ARTE DEL CAFÉ?
          </h2>
          <ul className="space-y-6" data-id="element-138">
            {solutions.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-139">
                <CheckCircle2 className="w-6 h-6 text-cta-600 flex-shrink-0 mt-0.5 bg-cream-100 rounded-full" data-id="element-140" />
                <span className="text-lg text-cream-200" data-id="element-141">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}